export const RESET = 'INTERNALANNOUNCEMENT_LIST_RESET'
export const SET_ITEMS = 'INTERNALANNOUNCEMENT_LIST_SET_ITEMS'
export const SET_ERROR = 'INTERNALANNOUNCEMENT_LIST_SET_ERROR'
export const SET_VIEW = 'INTERNALANNOUNCEMENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'INTERNALANNOUNCEMENT_LIST_TOGGLE_LOADING'
